import axios from "axios";
import { axiosAuthInterceptor } from "./axiosInterceptors";
import { csrfDataConnect } from "./csrfDataConnect";

const AUTH_API_ADDRESS = process.env.REACT_APP_AUTH_API_ADDRESS;

const userDataConnect = () => {
    return {
        reissueAccessToken: async () => {
            return await axios.post(
                `${AUTH_API_ADDRESS}/auth/v1/users/reissue/access-token`,
                null,
                {
                    withCredentials: true,
                    xsrfCookieName: "x_auth_csrf_token",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                },
            );
        },
        logoutLocal: async function () {
            await csrfDataConnect().getAuthCsrf();
            return await axiosAuthInterceptor.post(`${AUTH_API_ADDRESS}/auth/v1/users/logout/local`, null, {
                withCredentials: true,
                xsrfCookieName: 'x_auth_csrf_token',
                xsrfHeaderName: 'X-XSRF-TOKEN'
            })
        },
        getInfoOwn: async function () {
            return await axiosAuthInterceptor.get(`${AUTH_API_ADDRESS}/auth/v1/users/info`, {
                withCredentials: true,
                xsrfCookieName: 'x_auth_csrf_token',
                xsrfHeaderName: 'X-XSRF-TOKEN'
            })
        }
    }
}

export {
    userDataConnect
}